module.exports = __webpack_public_path__ + "c82d4e2338b39cabe188d3bf8587fd49.jpg";